import { AfterContentInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { UsuarioService } from "src/app/services/usuario.service";
import { Security } from "src/app/utils/security.util";
import { MaterialEntradaService } from "./../../services/material-entrada.service";
import { MaterialService } from "./../../services/material.service";
import { APP_SETTINGS } from "src/environments/environment";

@Component({
  selector: "app-entrada-material",
  templateUrl: "./entrada-material.component.html",
  styleUrls: ["./entrada-material.component.scss"],
})
export class EntradaMaterialComponent implements OnInit, AfterContentInit {
  constructor(
    private toastr: ToastrService,
    private materialService: MaterialService,
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private materialEntradaService: MaterialEntradaService,
    private modalService: NgbModal
  ) {}

  public autorizacoes: UsuarioAutorizacoes;

  materiaisDisponiveis: any[] = [];
  materiaisSelecionados: any[] = [];
  materiaisListGrid: any[] = [];
  todosMateriais: any[] = [];
  searchResult: any[] = [];

  isProcessing: boolean = false;
  qtdSelecionados: number = 0;
  nenhumResultadoEmPesquisa: boolean = false;
  valorTotalMateriaisInseridos: number = 0;

  public form: FormGroup = null;
  /*   public maskCnpj = [/[0-9]/, /[0-9]/,".", /[0-9]/, /[0-9]/, /[0-9]/, ".", /[0-9]/, /[0-9]/, /[0-9]/, "/", /[0-9]/,  /[0-9]/, /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
  ]; */

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("entrada-material");
  }

  ngOnInit() {
    this.resetForm();
    this.getMateriaisDisponiveis();
  }

  public resetForm(): void {
    this.form = this.formBuilder.group({
      id: [0],
      numeroDocumento: ["", [Validators.required]],
      dataHoraEntrada: [
        new Date(new Date().getTime() - 3 * 60 * 60 * 1000)
          .toISOString()
          .split(".")[0],
        [Validators.required],
      ],
      observacao: [""],
      usuarioCadastrouId: [Security.getUser().id],
      empresa: ["", [Validators.maxLength(60)]],
      cnpj: [""],
      chaveAcesso: ["", [Validators.maxLength(44)]],
      atualizaMaterialValor: APP_SETTINGS.AtualizaMaterialValor,
    });

    this.form.get("dataHoraEntrada").disable();
  }

  public reset() {
    this.resetForm();
    this.materiaisDisponiveis = [].concat(this.todosMateriais);
    this.limparDataListMateriais();
    this.materiaisSelecionados = [];
    this.isProcessing = false;
    this.qtdSelecionados = 0;
    this.nenhumResultadoEmPesquisa = false;
    //this.searchResult = [];
    this.valorTotalMateriaisInseridos = 0;
  }

  getMateriaisDisponiveis() {
    this.materialService.getMateriaisDisponiveis().subscribe((response) => {
      this.materiaisDisponiveis = response;
      this.limparDataListMateriais();
      this.todosMateriais = [].concat(response);
    });
  }

  async submit() {
    if (this.validForm()) {
      this.isProcessing = true;
      //this.form.get('dataHoraEntrada').enable()

      const materialEntrada = this.form.value;

      if (materialEntrada.id == 0) {
        materialEntrada.dataHoraEntrada = new Date(
          new Date().getTime() - 3 * 60 * 60 * 1000
        )
          .toISOString()
          .split(".")[0];
      } else {
        materialEntrada.dataHoraEntrada =
          this.form.get("dataHoraEntrada").value;
      }

      materialEntrada.movsOrdemMaterial = this.materiaisSelecionados.map(
        (x) => {
          return {
            id: 0,
            quantidade: Number(x.quantidade),
            valor: x.valor
              .replace(".", "")
              .replace(",", ".")
              .replace("R$", "")
              .trim(),
            materialId: x.materialId,
            materialEntradaId: this.form.get("id").value,
            entradaSaida: "E",
          };
        }
      );

      this.materialEntradaService.save(materialEntrada).subscribe(
        (response) => {
          if (response.success) {
            this.toastr.success(response.message);
            this.reset();
          } else {
            this.toastr.error(response.message);
            this.isProcessing = false;
          }
        },
        (err) => {
          this.toastr.error("Erro ao tentar salvar no banco");
          this.isProcessing = false;
        }
      );
    }
  }

  validForm() {
    if (this.materiaisSelecionados.length == 0) {
      this.toastr.warning("Selecione ao menos um material");
      return false;
    }

    return true;
  }

  selectMateriais(materialId: number) {
    this.materiaisDisponiveis.forEach((i) => {
      if (i.materialId === materialId) {
        i.marcado = !i.marcado;
      }
    });

    this.setResumosGridMateriaisInseridos();
  }

  setResumosGridMateriaisInseridos() {
    this.qtdSelecionados = this.materiaisSelecionados.length;
    this.valorTotalMateriaisInseridos = this.materiaisSelecionados
      .map((x) => x.rawSubTotal)
      .reduce((acumulator, currentValue) => (acumulator += currentValue), 0);
  }

  adicionarMateriais() {
    let totalMarcados = 0;

    this.materiaisDisponiveis.forEach((material) => {
      if (material.marcado) {
        totalMarcados++;
        const quantidade = <HTMLInputElement>(
          document.getElementById(`q${material.materialId}`)
        );

        const valor = <HTMLInputElement>(
          document.getElementById(`v${material.materialId}`)
        );

        if (quantidade.value == "" || valor.value == "") {
          material.touched = true;
          this.setResumosGridMateriaisInseridos();
          return;
        }

        const rawValue = Number(
          valor.value
            .toString()
            .replace(".", "")
            .replace(",", ".")
            .replace("R$", "")
            .trim()
        );

        material.marcado = false;
        material.touched = false;
        material.quantidade = quantidade.value;
        material.valor = valor.value.toString();
        material.subTotal = (
          rawValue * Number(quantidade.value)
        ).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
        material.rawSubTotal = rawValue * Number(quantidade.value);
        this.materiaisSelecionados.push(material);

        this.materiaisDisponiveis = this.materiaisDisponiveis.filter(
          (i2) => i2.materialId !== material.materialId
        );
        this.materiaisListGrid = this.materiaisListGrid.filter(
          (i2) => i2.materialId !== material.materialId
        );
      }
    });

    this.setResumosGridMateriaisInseridos();

    if (totalMarcados > 0) {
      // reordena pelo nome os materiais após a inserção
      this.materiaisSelecionados.sort((i1, i2) => {
        if (i1.descricao < i2.descricao) {
          return -1;
        }
        if (i1.descricao > i2.descricao) {
          return 1;
        }
        return 0;
      });
    } else {
      this.toastr.warning(
        "Selecione ao menos um material na grid 'Materiais disponíveis'"
      );
    }
  }

  removerMateriais(i: any) {
    i.marcado = false;
    i.touched = false;
    i.quantidade = 0;

    this.materiaisDisponiveis.push(i);
    this.materiaisListGrid.push(i);
    //const materiaisId = i.materialId;

    this.materiaisSelecionados = this.materiaisSelecionados.filter(
      (i2) => i2.materialId !== i.materialId
    );

    // reordena pelo nome os materiais após o retorno
    this.materiaisDisponiveis.sort((i1, i2) => {
      if (i1.descricao < i2.descricao) {
        return -1;
      }
      if (i1.descricao > i2.descricao) {
        return 1;
      }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.materiaisListGrid.sort((f1, f2) => {
      if (f1.descricao < f2.descricao) {
        return -1;
      }
      if (f1.descricao > f2.descricao) {
        return 1;
      }
      return 0;
    });

    this.setResumosGridMateriaisInseridos();
  }

  limparDataListMateriais() {
    (document.getElementById("datalistMateriais") as HTMLInputElement).value =
      "";
    this.materiaisListGrid = this.materiaisDisponiveis;
  }

  changeDataListMateriais(value: string) {
    if (value != "") {
      this.materiaisListGrid = this.materiaisDisponiveis.filter((t) =>
        t.descricao.toLowerCase().includes(value.toLowerCase()) ||
        t.codigo.toLowerCase().includes(value.toLowerCase()) ||
        t.ncm === null
          ? true
          : t.ncm.toString().toLowerCase().includes(value.toLowerCase()) ||
            t.tipoMaterialDescricao.toLowerCase().includes(value.toLowerCase())
      );
    }
  }

  openModalSearch(modal: any) {
    this.reset();
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  search(numeroDocumento) {
    this.nenhumResultadoEmPesquisa = false;

    this.materialEntradaService
      .getByPartNumeroDocumento(numeroDocumento)
      .subscribe((response: any[]) => {
        if (response.length > 0) {
          this.searchResult = response;
        } else {
          this.nenhumResultadoEmPesquisa = true;
          this.searchResult = [];
        }
      });
  }

  exibirEntradaMaterial(id) {
    this.reset();

    this.materialEntradaService.getById(id).subscribe((response) => {
      if (response) {
        this.form.patchValue({
          id: response.id,
          numeroDocumento: response.numeroDocumento,
          dataHoraEntrada: response.dataHoraEntrada.split(".")[0],
          observacao: response.observacao,
          usuarioCadastrouId: Security.getUser().id,
          empresa: response.empresa,
          cnpj: response.cnpj,
          chaveAcesso: response.chaveAcesso,
        });

        response.movsOrdemMaterial.forEach((x) => {
          this.materiaisSelecionados.push({
            id: x.id,
            descricao: x.material.descricao,
            codigo: x.material.codigo,
            unidade: x.material.unidade,
            valor: x.valor.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }),
            quantidade: Number(x.quantidade),
            materialId: x.material.id,
            touched: false,
            tipoMaterialDescricao: "",
            materialEntradaId: null,
            saldoCalculado: null,
            entradaSaida: null,
            saldo: 0,
            marcado: false,
            subTotal: (x.valor * x.quantidade).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }),
            rawSubTotal: x.valor * x.quantidade,
          });

          this.materiaisDisponiveis = this.materiaisDisponiveis.filter(
            (i2) => i2.materialId !== x.materialId
          );
          this.materiaisListGrid = this.materiaisListGrid.filter(
            (i2) => i2.materialId !== x.materialId
          );
        });

        this.setResumosGridMateriaisInseridos();

        this.modalService.dismissAll();
      }
    });
  }
  dadosXML: any;
  selecionarArquivo(): void {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xml";
    input.addEventListener("change", (event: any) => {
      const arquivoXML = event.target.files[0];
      this.carregarArquivo(arquivoXML);
    });
    input.click();
  }

  carregarArquivo(arquivoXML: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      const arquivoXML = reader.result as string;
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(arquivoXML, "text/xml");
      this.form.patchValue({
        numeroDocumento: this.getTagValue(xmlDoc, "cNF", false),
        empresa: this.getTagValue(xmlDoc, "emit", true, "xNome"),
        cnpj: this.getTagValue(xmlDoc, "emit", true, "CNPJ"),
        observacao: this.getTagValue(xmlDoc, "infAdic", true, "infCpl"),
        chaveAcesso: this.getTagValueAttrib(xmlDoc, "infNFe", "Id").substring(3),
      });

      const prodElements = xmlDoc.getElementsByTagName('prod');
      const element = document.getElementsByTagName("tbody")[0];
      const rows = element.getElementsByTagName("tr");
      
      for (let j = 0; j < prodElements.length; j++) {
        var foundNcm = "";
        
        for (let i = 0; i < rows.length; i++) {
          const cells = rows[i].getElementsByTagName("td");
          
          if (cells[0].getElementsByTagName("b").length > 0) {
            const b = cells[0].getElementsByTagName("b");

            if (b[0] != undefined) {
              foundNcm = b[0].textContent.trim();
            }
          }
                    
          if (foundNcm != undefined && foundNcm === this.getTagValue(prodElements[j], "NCM", false)) {
             (cells[2].getElementsByTagName("input")[0] as HTMLInputElement).value = this.getTagValue(prodElements[j], "qCom", false);
             (cells[3].getElementsByTagName("input")[0] as HTMLInputElement).value = this.getTagValue(prodElements[j], "vUnCom", false).replace('.', ',');
             const linha = rows[i] as HTMLTableRowElement;
             this.selectMateriais(parseInt(linha.id));
             this.adicionarMateriais();
          }
        }
      }
    };
    reader.readAsText(arquivoXML);
  }

  getTagValue(
    xmlDoc: any,
    parentTagName: string,
    hasTagChild: boolean,
    childTagName: string = ""
  ): string {
    const parentTag = xmlDoc.getElementsByTagName(parentTagName)[0];

    if (hasTagChild && parentTag) {
      const childTag = parentTag.getElementsByTagName(childTagName)[0];
      if (childTag) {
        return childTag.childNodes[0].nodeValue;
      }
    }

    if (parentTag) {
      return parentTag.childNodes[0].nodeValue;
    }
    return "";
  }

  getTagValueAttrib(
    xmlDoc: any,
    tagName: string,
    attributeName: string
  ): string {
    const tag = xmlDoc.getElementsByTagName(tagName)[0];
    if (tag) {
      return tag.getAttribute(attributeName);
    }
    return "";
  }
}
